export default {
    // Currently used
    home_search_for_product: "Pesquise o seu produto",
    conventional_alternative: "Alternativa Convencional",
    led_alternative: "Alternativa LED",
    search_filters_filter: "Filtro",
    alt_filters_filter: "Filtro Alternativo LED",
    search_submit: "Pesquisar produto",
    results: "Resultados",
    selected_product: "Produto selecionado",
    search_input: "Digite o código ou descrição do produto",
    what_type_are_you_looking_for: "Que tipo de produto de substituição está à procura?",
    recommendations_singular: "Recomendações",
    recommendations_plural: "Recomendações",
    your_product: "O seu produto",
    search_filters_reset: "Remover filtros",
    results_specify: "Existem mais de 10 resultados, por favor especifique a sua pesquisa",
    energy_efficient: "Eficiência energética",
    active_filters: "Ativar filtros",
    card_action: "Catálogo",
    card_show_more: "Mostrar mais",
    card_show_less: "Mostrar menos",
    card_alternative_fit: "Melhor alternativa Philips",
    card_perfect_fit: "A solução mais adequada da Philips",
    no_results_found: "Não há resultados. Por favor, tente com uma consulta de pesquisa diferente",
    results_no_recommendations: "Sem resultados? Entre em contato com o seu comercial da Signify para encontrar uma solução.",
    led_no_recommendations: "Não há alternativas de LED para este produto",
    ballast_notice: "É necessário verificar a compatibilidade do balastro electrónico.",
    ballast_notice_tled_link_text: "Lista de compatibilidade TLED",
    ballast_notice_pl_led_link_text: "Lista de compatibilidade PL LED",
    
    // LED facets
    search_filter_product_type: "Tipo de Produto",
    lighting_type: "Tipo de Lâmpada",
    ean: "EAN",
    product_code: "Código do produto",
    eoc: "EOC",
    family: "Família",
    discrete_wattage: "Potência",
    wattage: "Potência",
    brand: "Marca",
    driver_type: "Equipamento/driver",
    number_of_lamps: "Número de lâmpadas",
    length: "Comprimento",
    color: "Cor",
    base: "Base",
    local_eoc: "Código local",
    lumen: "Lúmen",
    energy_saving: "Economia de energia",
    tiering: "Categoria",
    ballast_compatibility: "Compatibilidade de balastro",
    lifetime: "Vida útil",

    // Conventional facets
    ignitor: "Arrancador",
    height: "Altura",
    width: "Largura",
    mounting_hole: "Montagem",
    mains_voltage: "Tensão de rede",
    thermal_protection: "Proteção térmica",
    delta_temperature: "Temperatura",
    energy_efficiency: "Eficiência energética",
    losses: "Perdas",
    lamp_current: "Lâmpada actual",
    pf_cap: "Ajuste perfeito",
};
